import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Field } from 'redux-form'
import { FormattedHTMLMessage } from 'react-intl'
import { FieldError } from 'components/misc'
import fieldId from 'constants/layout/fieldId'
import styles from './checkbox.styl'

export default class Checkbox extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    justify: PropTypes.bool,
    intlKey: PropTypes.string,
    intlValues: PropTypes.object,
    label: PropTypes.string,
    onChange: PropTypes.func,
    name: PropTypes.string.isRequired,
    validate: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.arrayOf(PropTypes.func)
    ])
  }

  static defaultProps = {
    validate: () => {}
  }

  handleChange = (field, e) => {
    if (this.props.onChange) {
      this.props.onChange(e.target.checked)
    }
    field.input.onChange(e.target.checked)
  }

  renderField = field => {
    const { input, meta } = field
    const {
      label,
      justify,
      disabled,
      name,
      intlKey,
      intlValues
    } = this.props
    const justifyClass = justify ? styles.justify : ''
    const disabledClass = disabled ? styles.disabled : ''

    return (
      <div className={`${styles.controls} ${justifyClass} ${disabledClass}`}>
        <input
          className={`form-control ${styles.formControl}`}
          type="checkbox"
          id={`id-${name}`}
          checked={field.input.value}
          {...field.input}
          onChange={e => this.handleChange(field, e)}
          disabled={disabled}
        />
        <label className={`${styles.controlLabel}`} htmlFor={`id-${name}`}>
          {intlKey
            ? <FormattedHTMLMessage
                id={intlKey}
                defaultMessage={label}
                values={intlValues}
            />
            : label}
        </label>
        <FieldError toShow={meta.touched && meta.error} message={meta.error} />
      </div>
    )
  }

  render() {
    return (
      <div className="form-group" id={`${fieldId}.${name}`}>
        <Field
          name={this.props.name}
          component={this.renderField}
          validate={this.props.validate}
        />
      </div>
    )
  }
}
